import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", ...l }, /* @__PURE__ */ e.createElement("path", { fill: "#4D4E58", fillRule: "evenodd", d: "M5.646 12.354a.5.5 0 0 1 0-.708L9.293 8 5.646 4.354a.5.5 0 1 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708 0Z", clipRule: "evenodd" }));
export {
  t as default
};
